import { TranslatableLabelEntryVO } from './translatable-label-entry.vo';
import { TranslatedEmb, TranslatedKeyPair } from '@wizeoo/akm-message-lib';
import { IWizTranslationEntry, WizStringUtils } from '@wizeoo/akm-core-lib';
import { trim } from 'lodash-es';
/**
 * VO de champ traduit
 */
export class TranslatableLabelVO {

  /**
   * Constructeur
   * @param pSource vo source du back
   */
  constructor(pSource?: TranslatedEmb) {
    this._source = pSource ? pSource : new TranslatedEmb();
  }

  /**
   * Le vo source provenant du back
   */
  private _source: TranslatedEmb;

  public set source(entry: TranslatedEmb) {
    this._source = entry;
  }
  public get source(): TranslatedEmb {
    return this._source;
  }


  /** Map de traductions (objets back du source) */
  public get entries(): {[key: string]: TranslatedKeyPair} {
    if (!this._source.keys) {
      this._source.keys = {};
    }
    return this._source.keys;
  }
  public set entries(value: {[key: string]: TranslatedKeyPair})  {
    this._source.keys = value;
  }


  /* #############################################################
          accesseurs composites
     ############################################################# */

  /** Map des entrées sous forme de VO codelang = VO */
  private _entriesVOMap: Map<string, TranslatableLabelEntryVO>;

  public get entriesVOMap(): Map<string, TranslatableLabelEntryVO> {
    if (!this._entriesVOMap) { // la map n'existe pas encore, initialisation
      this._entriesVOMap = new Map<string, TranslatableLabelEntryVO>();

      Object.values(this.entries).forEach(element => {
        const vo: TranslatableLabelEntryVO = new TranslatableLabelEntryVO(element);
        this._entriesVOMap.set(vo.languageCode, vo);
      });
    }
    return this._entriesVOMap;
  }


  /* #############################################################
          manipulation
     ############################################################# */

  /**
   * Mise à jour d'une entrée de traduction
   * @param entry Objet contenant l'identification et la valeur de la traduction
   */
  public updateTranslationEntry(entry: IWizTranslationEntry): void {
    if (entry && entry.languageCode) {
      const exisitingEntry: TranslatableLabelEntryVO = this.entriesVOMap.get(entry.languageCode); // recherche de l'existant

      if (!exisitingEntry && !WizStringUtils.isEmpty(entry.label)) { // n'existe pas, et un contenu, création
        const newEntryVO: TranslatableLabelEntryVO = new TranslatableLabelEntryVO();
        newEntryVO.languageCode = entry.languageCode;
        newEntryVO.label = entry.label;
        this.addEntry(newEntryVO);
      } else if (exisitingEntry) { // existe, simple mise à jour
          exisitingEntry.label = entry.label;
      }
    }
  }

  /**
   * Ajout d'une nouvelle entrée de traduction
   * @param vo VO de traduction ajouté
   */
  public addEntry(vo: TranslatableLabelEntryVO): void {
    this.entries[vo.languageCode] = vo.source; // ajout à l'objet source
    this.entriesVOMap.set(vo.languageCode, vo); // et ajout à la Map
  }

  /**
   * Suppression d'une entrée de traduction
   * @param vo VO de traduction supprimé
   */
  public removeEntry(vo: TranslatableLabelEntryVO): void {
    delete this.entries[vo.languageCode]; // suppression de l'objet source
    this.entriesVOMap.delete(vo.languageCode); // suppression de la map
  }

  /** retourne TRUE si a minima une entrée */
  public hasEntry(): boolean {
    let result: boolean = false;
    Array.from(this.entriesVOMap.values()).forEach((tevo: TranslatableLabelEntryVO) => {
      if (!!tevo.label && trim(tevo.label).length > 0) {
        result = true;
      }
    });
    return result;
  }
}
